// components/Header.js
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Link from "next/link";
import SearchInput from "../components/SearchInput";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

const linkStyle = {
  color: "rgb(113, 128, 150)",
  fontSize: "18px",
  fontWeight: 700,
  lineHeight: "28px",
  textTransform: "none",
  textDecoration: "none",
  "&:hover": {
    color: "#667EEA", // Hover text color
    backgroundColor: "transparent", // Prevents background change
  },
};

const menuItems = [
  { text: "Home", href: "/home" },
  { text: "About Me", href: "/about" },
  { text: "Contact", href: "/contact" },
  { text: "Blog", href: "/blog" },
];

const mobileMenuItems = [
  { text: "Javascript", href: "/blog/javascript" },
  { text: "React", href: "/blog/react" },
  { text: "Typescript", href: "/blog/typescript" },
];

export default function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const [searchOpen, setSearchOpen] = useState(false);
  const handleSearchOpen = () => setSearchOpen(true);
  const handleSearchClose = () => setSearchOpen(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box sx={{ position: "relative", padding: "20px" }}>
      {/* Close Button */}
      <IconButton
        aria-label="Close menu"
        onClick={handleDrawerToggle}
        sx={{
          position: "absolute",
          left: 10,
          top: 10,
          color: "rgb(113, 128, 150)",
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Main Menu Section */}
      <Typography
        sx={{
          color: "#2D3748",
          fontWeight: 700,
          fontSize: "20px",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "10px",
        }}
      >
        Main Menu
      </Typography>

      <List>
        {menuItems.map((item) => (
          <ListItem
            key={item.text}
            component={Link}
            href={item.href}
            onClick={handleDrawerToggle}
            sx={{
              "&:hover": {
                backgroundColor: "#EDF2F7",
              },
            }}
          >
            <ListItemText
              primary={item.text}
              sx={{
                color: "rgb(113, 128, 150)",
                "& .MuiListItemText-primary": {
                  fontWeight: 700,
                  fontSize: "16px",
                },
              }}
            />
          </ListItem>
        ))}
      </List>

      <Divider sx={{ margin: "20px 0" }} />

      {/* Topics Section */}
      <Typography
        sx={{
          color: "#2D3748",
          fontWeight: 700,
          fontSize: "20px",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Technologies
      </Typography>

      <List>
        {mobileMenuItems.map((item) => (
          <ListItem
            key={item.text}
            component={Link}
            href={item.href}
            onClick={handleDrawerToggle}
            sx={{
              "&:hover": {
                backgroundColor: "#EDF2F7",
              },
            }}
          >
            <ListItemText
              primary={item.text}
              sx={{
                color: "rgb(113, 128, 150)",
                "& .MuiListItemText-primary": {
                  fontWeight: 700,
                  fontSize: "16px",
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#ffffff",
        boxShadow: "none",
        padding: "20px 0px",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Logo/Site Name */}
          <Typography component={Link} href="/home" variant="h6" sx={linkStyle}>
            Valentin-Marko
          </Typography>

          {/* Desktop Search - centered */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              textAlign: "center",
            }}
          >
            <SearchInput
              open={searchOpen}
              onOpen={handleSearchOpen}
              onClose={handleSearchClose}
            />
          </Box>

          {/* Desktop Navigation */}
          <Box
            sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}
          >
            {menuItems.map((item) => (
              <Button
                key={item.text}
                component={Link}
                href={item.href}
                sx={linkStyle}
              >
                {item.text}
              </Button>
            ))}
          </Box>

          {/* Mobile buttons */}
          <Box sx={{ display: { md: "none" }, alignItems: "center" }}>
            <IconButton
              aria-label="Open Search"
              onClick={handleSearchOpen}
              sx={{
                color: "rgb(113, 128, 150)",
                fontWeight: 900,
              }}
            >
              <SearchIcon sx={{ fontSize: { xs: "22px", sm: "34px" } }} />
            </IconButton>
            <IconButton
              color="inherit"
              aria-label="Open menu"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{
                color: "rgb(113, 128, 150)",
                marginLeft: "8px",
              }}
            >
              <MenuIcon sx={{ fontSize: { xs: "22px", sm: "34px" } }} />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>

      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "100%",
            maxWidth: "500px",
            backgroundColor: "#ffffff",
          },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
}
